/* eslint-disable import/no-unresolved */
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useState } from "react";
import CustomSuccessModal from "src/shared/CustomSuccessModal";
import { SET_TOAST_ERROR, setMefUploadModal } from "src/redux/Actions/common";
import { getReviewDetails } from "src/services/LeadInfo";
import store from "src/redux/store";
import { setReviewDetails } from "src/redux/Thunk";
import { EInsurerType } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import CustomLoader from "src/shared/CustomLoader";
import InformationModal from "src/shared/InformationModal";
import { loanPageHelperText } from "src/helpers/FormDetails/ProposalDetails/resources";
import CustomBoxModal from "src/shared/CustomModalBox";
import UploadDocument from "src/shared/UploadDocument";
import { UploadSignedMefForm as uploadMEFForm } from "src/services/UploadSignedMefForm";
import ProposalOtp from "../ProposalOtp";

function DownloadAndVerify() {
  const { leadId } = useParams();
  const { isFetching: isReviewLeadFetching, isError: isGetReviewError } = useQuery(
    ["getReviewDetails"],
    () => getReviewDetails(leadId || ""),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!leadId,
      onSuccess: (response) => {
        store.dispatch(setReviewDetails(response.data, leadId || ""));
      }
    }
  );
  const modalState = useAppSelector((state) => state.mefUploadModal.modalState);
  const [showUploadSignedForm, setUploadSignedForm] = useState(false);
  const [showModal, setShowModal] = useState(false || modalState);
  const [mefFile, setMefFile] = useState<File | null>(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const { mutate: mutateMEFUpload, isLoading: isUploadMEFLoading } = useMutation(uploadMEFForm, {
    retry: false,
    onSuccess: async () => {
      setShowModal(true);
      setUploadSignedForm(false);
      store.dispatch(setMefUploadModal({ modalState: true }));
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "success",
          message: "Successfully Uploaded MEF Form"
        })
      );
    },
    onError: () => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: "Failed to upload MEF. Try again"
        })
      );
    }
  });

  const handleMEFUpload = () => {
    mutateMEFUpload({ leadId, file: mefFile });
  };

  const handleDeclarationChange = () => {
    setUploadSignedForm(true);
    setShowCustomModal(false);
  };

  const handleUploadClick = () => {
    setShowCustomModal(true);
  };

  if (isReviewLeadFetching || isUploadMEFLoading) {
    return <CustomLoader />;
  }

  if (isGetReviewError) {
    return <div className="text-center mt-20 text-2xl font-bold text-hotShot">No Data Found</div>;
  }

  return (
    <div>
      {showModal && (
        <CustomSuccessModal
          shortMessage="Successful"
          longMessage="Your MEF has been submitted."
          isButtonEnable
        />
      )}
      <div className=" bg-whiteSmoke pt-8 mx-auto">
        <ProposalOtp insurerType={EInsurerType.ALL} />
        {showUploadSignedForm && (
          <CustomBoxModal
            onClose={() => {
              setUploadSignedForm(false);
              setShowCustomModal(false);
              setMefFile(null);
            }}
          >
            <div>
              <UploadDocument
                className="w-64 md:w-105"
                title="Upload File"
                description={mefFile?.name ? mefFile?.name : "Click to select or drag and drop"}
                supportedFileText="SVG, PNG, JPG, PDF or GIF (Max 800x400 px)"
                setFile={setMefFile}
                acceptedFiles={loanPageHelperText?.mefSupportedFile}
              />
            </div>
            <div className="text-center px-4 my-2">
              <Button
                disabled={
                  !(
                    mefFile &&
                    loanPageHelperText?.mefSupportedFile?.includes(
                      `.${mefFile?.name?.split(".")?.pop()?.toLowerCase()}`
                    )
                  )
                }
                variant="contained"
                onClick={handleMEFUpload}
                className="!capitalize h-10 w-32 rounded-lg"
              >
                Submit
              </Button>
            </div>
          </CustomBoxModal>
        )}
        {!showUploadSignedForm && showCustomModal && (
          <InformationModal
            text={
              <div>
                <p>
                  Please upload only MEF copy on CLC portal & send PAF & any other requirements to
                  <span className="text-blue-900 italic"> Docs.group@ageasfederal.com </span>
                  e-mail id.
                </p>
              </div>
            }
            onNext={handleDeclarationChange}
          />
        )}
        <div className="mx-auto xl:w-290 w-auto mt-6 rounded-lg flex justify-center pb-4 pt-4 bg-white">
          <Button
            variant="outlined"
            className="!uppercase h-13 rounded-lg !mr-10"
            onClick={() => window.scrollTo(0, 0)}
          >
            BACK TO TOP
          </Button>
          <Button
            onClick={handleUploadClick}
            variant="contained"
            className="!uppercase h-13  rounded-lg"
          >
            UPLOAD
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DownloadAndVerify;
